import React, { Component } from 'react'
import { HexColorPicker, HexColorInput } from 'react-colorful'
import './styles/colorPicker.scss'

class ColorPicker extends Component {
    constructor(props) {
        super(props)
        this.state = {
            color: props.defaultValue || '#fffff',
            togglePicker: false,
        }
        this.wrapperRef = React.createRef()
        this.handleClickOutside = this.handleClickOutside.bind(this)
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside)
    }

    componentWillUnmount() {
        const { unregister, name, path } = this.props
        if (typeof unregister === 'function') {
            unregister(name, path)
        }

        document.removeEventListener('mousedown', this.handleClickOutside)
    }

    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
            this.setState({ showPicker: false })
        }
    }

    setColor = (color) => {
        const { name, onChange } = this.props
        this.setState({ color })
        if (onChange) onChange(color, name)
    }

    togglePicker = () => {
        this.setState((prevState) => ({
            ...prevState,
            showPicker: !prevState.showPicker,
        }))
    }

    onBlur = () => {
        const { name, onBlur } = this.props
        const { color } = this.state
        if (typeof onBlur === 'function') {
            onBlur({ name, value: color })
        }
    }

    renderPreviewDiv = (color) => (
        <div
            style={{
                height: '20px',
                width: '20px',
                backgroundColor: color,
                border: '1px solid grey',
                marginInline: '-60px 30px',
            }}
        />
    )

    render() {
        const { color, showPicker } = this.state
        const { label, position, showPreview } = this.props
        return (
            <div className="uc-colorPicker">
                <div className={`pickerWrapper ${showPicker ? 'show' : 'hide'} ${position || 'top'}`} ref={this.wrapperRef}>
                    <HexColorPicker color={color} onChange={this.setColor} onBlur={this.onBlur} />
                </div>
                <div className="label">{label}</div>
                <div className="colorInput">
                    <HexColorInput prefixed className="colorPickerInput" color={color} onChange={this.setColor} onBlur={this.onBlur} />
                    {showPreview && this.renderPreviewDiv(color)}
                    <i className="fa-regular fa-eye-dropper dropper" onClick={this.togglePicker} />
                </div>
            </div>
        )
    }
}

export default ColorPicker
